<template>
	<div class="flex flex-col gap-2 bg-white shadow sm:rounded-lg p-4 m-2">
		<div class="flex items-center justify-between w-full gap-2">
			<PageLabel :helpPageName="'subProjects'">Sub Projects</PageLabel>
			<div class="flex flex-row items-center gap-2">
				<Button class="btn btn-primary" id="btnNewUser" @click="newSubProject()" v-if="SessionInfo.hasRightsToScreen('Projects', PageAccess.Create)">
					<font-awesome-icon :icon="['far', 'suitcase']" />New Sub Project
				</Button>
			</div>
		</div>
		<DataTable
			:value="subProjectsList"
			responsiveLayout="scroll"
			:row-hover="true"
			:paginator="true"
			:rows="tablePaginator == null ? 10 : tablePaginator.rows"
			:first="tablePaginator == null ? 0 : tablePaginator.first"
			:page="tablePaginator == null ? 0 : tablePaginator.page"
			@page="pageChanged($event)"
			paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
			:rowsPerPageOptions="[10, 20, 50]"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
			dataKey="id"
			v-model:filters="usersFilters"
			filterDisplay="menu"
			@filter="applyFilter($event)"
			:loading="loading1"
			:globalFilterFields="['subProjectName', 'defaultScreens', 'subProjectCollaboratorList']"
			id="dtSubProjectList"
			:rowClass="rowClass"
		>
			<template #header>
				<div class="p-d-flex p-jc-between">
					<Button icon="pi pi-filter-slash" label="Clear" @click="usersFilters['global'].value = null" />
					<span class="relative">
						<i class="pi pi-search absolute inset-y-3 right-3 flex items-center pointer-events-none"></i>
						<InputText class="pl-10" v-model="usersFilters['global'].value" placeholder="Keyword Search" id="UserKeywordSearch" />
					</span>
				</div>
			</template>
			<template #empty> No sub projects found. </template>
			<template #loading> Loading sub project. Please wait. </template>
			<Column field="subProjectName" filterField="subProjectName" header="Sub Project Name" :sortable="true" style="flex: 0 0 30%">
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">{{ data.subProjectName }}</div>
				</template>
			</Column>
			<Column
				field="assessmentCount"
				filterField="assessmentCount"
				header="Assessment Count"
				:sortable="false"
				style="flex: 0 0 45%; text-align: center"
			>
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						<!-- {{ data.subProjectDefaultScreen ? skillAreaList(Object.values(data.subProjectDefaultScreen)) : "" }} -->
						{{ data.subProject.assessment.filter((item: Assessment) => item.isActive === true).length }}
					</div>
				</template>
			</Column>
			<Column field="defaultScreens" filterField="defaultScreens" header="Module" :sortable="true" style="flex: 0 0 35%">
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						<!-- {{ data.subProjectDefaultScreen ? skillAreaList(Object.values(data.subProjectDefaultScreen)) : "" }} -->
						{{ data.defaultScreens }}
					</div>
				</template>
			</Column>

			<Column
				field="subProjectCollaboratorList"
				filterField="subProjectCollaboratorList"
				header="Collaborators"
				:sortable="true"
				style="flex: 0 0 45%"
			>
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						<!-- {{ data.subProjectCollaborator ? collaboratorsList(Object.values(data.subProjectCollaborator)) : "" }} -->
						{{ data.subProjectCollaboratorList }}
					</div>
				</template>
			</Column>
			<!-- <Column
				field="subProject.createdTimestamp"
				filterField="createdTimestamp"
				header="Sub Project Creation Date"
				:sortable="true"
				style="flex: 0 0 45%"
			>
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						{{ data.projectCollaborator ? collaboratorsList(Object.values(data.projectCollaborator)) : "" }}
						{{ useDateTimeHelper(data.subProject.createdTimestamp).toLocalTimeZoneStandardFormat() }}
					</div>
				</template>
			</Column> -->
			<Column header="Created" sortable style="flex: 0 0 45%">
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						<I2TimestampDisplay :date="data.subProject.createdTimestamp" :user="data.subProject.createdByPerson" />
					</div>
				</template>
			</Column>
			<Column field="subProject.updatedTimestamp" filterField="updatedTimestamp" header="Last Modified" :sortable="true" style="flex: 0 0 45%">
				<template #body="{ data }">
					<div class="w-full" @click="selectProject(data)">
						<!-- {{ data.projectCollaborator ? collaboratorsList(Object.values(data.projectCollaborator)) : "" }} -->
						<!-- {{ useDateTimeHelper(data.subProject.updatedTimestamp).toLocalTimeZoneStandardFormat() }} -->
						<I2TimestampDisplay :date="data.subProject.updatedTimestamp" :user="data.subProject.updatedByPerson" />
					</div>
				</template>
			</Column>
			<Column field="id" header="Actions" style="width: 11%" styleClass="tdLessPadding">
				<template #body="slotProps"
					><span style="cursor: pointer"
						><FontAwesomeIcon
							:icon="['far', 'pen']"
							title="Modify"
							@click="editProject(slotProps.data.subProject)"
							v-show="SessionInfo.hasRightsToScreen('Projects', PageAccess.Update)" /></span
					><span style="cursor: pointer"
						><FontAwesomeIcon
							:icon="['far', 'info-circle']"
							title="View"
							@click="editProject(slotProps.data.subProject)"
							class="ml-2"
							v-show="!SessionInfo.hasRightsToScreen('Projects', PageAccess.Update)" /></span
					><span style="cursor: pointer"
						><FontAwesomeIcon
							:icon="['far', 'trash']"
							title="Delete"
							@click="deleteProject(slotProps.data.subProject)"
							class="ml-2"
							v-show="SessionInfo.hasRightsToScreen('Projects', PageAccess.Delete)" /></span></template
			></Column>
		</DataTable>
		<div v-if="showDialog">
			<subProjectEdit
				:subProject="subProject"
				:projectId="route.query.projectId?.toString()"
				:allSubProjects="subProjectsList"
				@cancel="cancel()"
				@save="save()"
				:multipleSelection="multipleSelection"
				:subProjectsList="subProjectsList"
			/>
		</div>

		<Dialog v-model:visible="showDialogDelete" :modal="true" style="width: 35vw" :closable="false" contentStyle="overflow:visible">
			<template #header>
				<PageLabel :helpPageName="'projectDelete'">Delete Assessment </PageLabel>
			</template>
			<FormCard>
				<I2FormRow class="mt-6">
					<h1>Are you sure you would like to delete selected Assessment?</h1>
				</I2FormRow>
			</FormCard>
			<template #footer>
				<I2FormRow right>
					<Button label="Cancel" class="inverted mr-4" @click="showDialogDelete = false" right />
					<Button label="Delete" class="ml-4" @click="deleteProjectOK()" right />
				</I2FormRow>
			</template>
		</Dialog>
	</div>
</template>
<script setup lang="ts">
import { ref, onMounted, reactive, computed } from "vue"
import Dialog from "primevue/dialog"
import { ApiClient, Project, ProjectCollaborator, SubProjectDefaultScreen, SubProject, Assessment } from "../../entities/NSwagGenerated"
import { EventBus } from "../eventBus"
import { useRouter, useRoute } from "vue-router"
import { FilterMatchMode, FilterOperator } from "@primevue/core/api"
import Button from "primevue/button"
import InputText from "primevue/inputtext"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
import PageLabel from "./pageLabel.vue"
import DataTable, { DataTablePageEvent, DataTableFilterEvent } from "primevue/datatable"
import Column from "primevue/column"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle, faTrash, faPen, faSuitcase } from "@fortawesome/pro-regular-svg-icons"
import { useDateTimeHelper } from "@/composables/dateTimeHelper"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import subProjectEdit from "./subProjectEdit.vue"
import I2TimestampDisplay from "./I2TimestampDisplay.vue"
library.add(faTrash, faPen, faInfoCircle, faSuitcase)

//Set this option to enable "Default Screen" multiselect
let multipleSelection = true

const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const subProjectsList = ref()
let showDialog = ref(false)
let showDialogDelete = ref(false)
let tablePaginator: any | null = null
const selectedSubProjectId = ref()
let loading1: any = null
const router = useRouter()
const route = useRoute()
const subProject = ref(new SubProject())
const projectId = ref<string | undefined>(undefined)

let usersFilters = reactive({
	global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	subProjectName: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	subProjectDefaultScreen: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
	subProjectCollaborator: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
})
const props = defineProps({
	routeParams: {
		type: Object,
		required: true,
	},
})
onMounted(() => {
	EventBus.emit("buildBreadcrumb", {
		type: "subproject",
		label: "",
		id: route.query.projectId,
	})
	refresh()
})

function save() {
	showDialog.value = false
	refresh()
}
function cancel() {
	selectedSubProjectId.value = null
	showDialog.value = false
	refresh()
}
function newSubProject() {
	selectedSubProjectId.value = null
	subProject.value = new SubProject()
	showDialog.value = true
}
function deleteProject(data: Project) {
	selectedSubProjectId.value = data.id
	showDialogDelete.value = true
}
function deleteProjectOK() {
	apiClient.subProjectDelete(selectedSubProjectId.value).then(
		(result) => {
			refresh()
			showDialogDelete.value = false
		},
		(err) => {
			throw err
		}
	)
}
function selectProject(data: SubProject) {
	selectedSubProjectId.value = data.id
	localStorage.setItem("selectedSubProjectId", JSON.stringify(data.id))
	// 	type: "subproject",
	// 	label: data.subProjectName,
	// 	id: data.id,
	// })
	router.push({ name: "assessmentList", query: { subProjectId: data.id } })
}
function editProject(data: any) {
	subProject.value = data
	showDialog.value = true
}

function collaboratorsList(list: any) {
	let collaboratorsList = new Array<string>()
	list.forEach((el: ProjectCollaborator) => {
		if (el.person) collaboratorsList.push(el.person.firstName + " " + el.person.lastName)
	})
	return collaboratorsList.join(",")
}
function skillAreaList(list: any) {
	let skillAreaList = new Array<string>()
	list.forEach((list: SubProjectDefaultScreen) => {
		if (list.screen && list.screen.screenName !== undefined) skillAreaList.push(list.screen.screenName)
	})
	return skillAreaList.join(",")
}

function pageChanged(ev: DataTablePageEvent) {
	tablePaginator = ev
	localStorage.setItem("projectListPaginate", JSON.stringify(ev))
}

function applyFilter(ev: DataTableFilterEvent) {
	localStorage.setItem("tableUserFilter", JSON.stringify(usersFilters))
}

function refresh() {
	var projectId = route.query.projectId?.toString()
	apiClient!.subProjectPerProjectTable(projectId).then(
		(result) => {
			subProjectsList.value = result
		},
		(err) => {
			throw err
		}
	)
}

function rowClass(data: any) {
	const assessmentCount = data.subProject?.assessment?.filter((item: Assessment) => item.isActive === true).length || 0
	return assessmentCount > 0 ? "row-with-assessments" : ""
}
</script>

<style></style>
